module.exports = __webpack_public_path__ + "img/slide18.13c14a13.jpg";